"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusNoOp = exports.userStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const string_1 = require("../options/string");
const enums_1 = require("../enums");
/**
 * User status object to be returned in a header alongside most responses.
 */
// eslint-disable-next-line import/prefer-default-export
exports.userStatus = typebox_1.Type.Object({
    status: typebox_1.Type.Enum(enums_1.UserStatus, {
        description: 'current status of the user',
        example: enums_1.UserStatus.Parking,
    }),
    nextParkingAllowed: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.dateTime), { description: 'next point in time when starting parking is allowed' })),
});
/**
 * A response body type to indicate successful querying of the status endpoint.
 */
exports.statusNoOp = typebox_1.Type.Null({
    description: 'status endpoint queried successfully',
});
//# sourceMappingURL=status.js.map